// extracted by mini-css-extract-plugin
export var centerText = "_5t-8";
export var container = "_5t-0";
export var doughnutContainer = "_5t-7";
export var legend = "_5t-a";
export var legendItemColorDisplay = "_5t-b";
export var legendItemLabel = "_5t-d";
export var legendItemValue = "_5t-c";
export var lg = "_5t-5";
export var maxWidth = "_5t-9";
export var md = "_5t-4";
export var responsive = "_5t-6";
export var sm = "_5t-3";
export var xs = "_5t-2";
export var xxs = "_5t-1";